import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import Modal from '../common/Modal/Modal';
import '../../styles/insightCards.css';

const IMG_SRC = '/AMERICAN_LOBSTER_LANDINGS.jpg';

export default function LobsterLandings(_props: RegistryComponentProps): React.ReactElement {
  const [showLobsterLandingsModal, setShowLobsterLandingsModal] = useState(false);

  const handleMouseEnter = (e: React.MouseEvent<HTMLImageElement>) => {
    const el = e.currentTarget;
    el.style.transform = 'scale(1.02)';
    el.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLImageElement>) => {
    const el = e.currentTarget;
    el.style.transform = 'scale(1)';
    el.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
  };

  return (
    <>
      <div className="insight-card">
        <div className="insight-title-row">
          <h3 className="insight-title">Landings</h3>
        </div>
        <div>
          <img
            src={IMG_SRC}
            alt="American Lobster - Landings"
            onClick={() => setShowLobsterLandingsModal(true)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{
              maxWidth: '100%',
              height: 'auto',
              borderRadius: '6px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              cursor: 'pointer',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            }}
          />
        </div>
      </div>

      {showLobsterLandingsModal &&
        createPortal(
          <Modal
            title="American Lobster - Landings"
            onClose={() => setShowLobsterLandingsModal(false)}
            size="extra-large"
            transparentBackdrop={true}
            parameterStyle={true}
            {...({ customMaxWidth: '90vw', customMaxHeight: '90vh' } as Record<string, unknown>)}
            bodyStyle={{ padding: '20px' }}
          >
            <img
              src={IMG_SRC}
              alt="American Lobster - Landings"
              style={{ maxWidth: '100%', height: 'auto', borderRadius: '6px' }}
            />
          </Modal>,
          document.body
        )}
    </>
  );
}
